import React, { Fragment, useRef, useState } from 'react';
import { Popover, styled } from '@mui/material';
import { GraphDataPoint } from '../../interfaces/graphInterfaces';

const classesPrefix = 'boxGraphSection';

const classes = {
    popover: `${classesPrefix}-popover`,
    paper: `${classesPrefix}-paper`,
    name: `${classesPrefix}-name`,
};

const StyledPopover = styled(Popover)(({ theme }) => {
    return {
        [`&.${classes.popover}`]: {
            pointerEvents: 'none',
        },
        [`& .${classes.paper}`]: {
            marginTop: theme.spacing(1),
            display: 'flex',
            justifyContent: 'center',
        },
        [`& .${classes.name}`]: {
            padding: theme.spacing(1),
            fontSize: theme.typography.body2.fontSize,
        },
    };
});

const BoxGraphSection = ({
    graphDataItem,
    color,
}: {
    graphDataItem: GraphDataPoint;
    color: string;
}): React.JSX.Element => {
    const ref = useRef<HTMLDivElement | null>(null);
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

    const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>): void => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = (): void => {
        setAnchorEl(null);
    };

    return (
        <Fragment>
            <div
                key={graphDataItem.name}
                ref={ref}
                aria-owns={anchorEl ? 'mouse-over-popover' : undefined}
                aria-haspopup='true'
                onMouseEnter={handlePopoverOpen}
                onMouseLeave={handlePopoverClose}
                style={{
                    backgroundColor: color,
                    flexGrow: graphDataItem.value ?? 0,
                }}
            />
            <StyledPopover
                id='mouse-over-popover'
                className={classes.popover}
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                onClose={handlePopoverClose}
                disableRestoreFocus
                PaperProps={{
                    style: {
                        width: graphDataItem.tooltipContents ? ref?.current?.clientWidth : 'auto',
                    },
                    className: classes.paper,
                }}
            >
                {
                    graphDataItem.tooltipContents ?
                        graphDataItem.tooltipContents :
                        <span className={classes.name}>{graphDataItem.name}</span>
                }

            </StyledPopover>
        </Fragment>
    );
};

export default BoxGraphSection;
